import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

const DEFAULT_DESCRIPTION = 'Turn your pet into a masterpiece. Fine art portraits in the style of Da Vinci, Van Gogh, Warhol and more — framed and delivered to your door.';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly document = inject(DOCUMENT);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    this.title.setTitle(
      routeTitle ? `${routeTitle} | The Perfect Muse` : 'The Perfect Muse | Fine Art Pet Portraits'
    );

    const data = this.getLeafData(snapshot.root);

    const description = data['description'] ?? DEFAULT_DESCRIPTION;
    this.meta.updateTag({ name: 'description', content: description });

    const canonical = data['canonical'];
    if (canonical) {
      let link = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        this.document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
  }

  private getLeafData(route: ActivatedRouteSnapshot): Record<string, string> {
    let data: Record<string, string> = { ...route.data };
    for (const child of route.children) {
      data = { ...data, ...this.getLeafData(child) };
    }
    return data;
  }
}
